// /bookmarks DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정.

import React from "react";
import { Link } from "react-router-dom";
import { EditButton } from "@refinedev/mui";
import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { OverflowTooltip } from "components/list";
import { IBookmark } from "../interfaces";

const linkStyle: React.CSSProperties = {
  textDecoration: "underline",
  fontWeight: 600,
  color: "var(--color-primary)",
};

export const bookmarkColumns: GridColDef<IBookmark>[] = [
  {
    field: "id",
    headerName: "ID",
    type: "number",
    width: 84,
    minWidth: 72,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "userId",
    headerName: "사용자ID",
    type: "string",
    width: 120,
    minWidth: 100,
    renderCell: (params: GridRenderCellParams) => (
      <OverflowTooltip value={params.value}>
        <Link to={`/users/show/${params.value}`} style={linkStyle}>
          {params.value}
        </Link>
      </OverflowTooltip>
    ),
  },
  {
    field: "boardId",
    headerName: "이야기게시판ID",
    type: "string",
    width: 140,
    minWidth: 110,
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 100,
    minWidth: 90,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <EditButton hideText recordItemId={params.row.id} />
    ),
  },
];
